<template>
    <div>
        <employer-notes :employer_id="employerId" type="note" />
        <employer-notes :employer_id="employerId" type="score" />
    </div>
</template>

<script>
export default {
        props: [
            'employerId'
        ],
    }
</script>
